export const ReportType = {
  ACTIVE: 'active',
  ACTIVE_PAST: 'active_past',
  ACTIVE_FUTURE: 'active_future',
};
